import AutoNumeric from "autonumeric";
import { loadPhoneNumber, formatPhoneNumber } from "../../../backoffice/utils";
import "../../../../stylesheets/profile";
import { lightOrDark } from "../../../utils";

$(document).ready(() => {
  $(".profile-submit-btn").on("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    let amount_validity = validateSubscriptionAmount();
    if (amount_validity) {
      $(".edit-subscription").submit();
    }
  });
  $("#amount-field").on("blur", () => {
    validateSubscriptionAmount();
  });

  loadPhoneNumber();
  $("#donator_subscriptions_attributes_0_currency").on("change", function () {
    var currency = $("#donator_subscriptions_attributes_0_currency").val();
    if (currency == "uf") {
      amountin[0].update({
        digitGroupSeparator: "",
        decimalCharacter: ".",
        decimalPlaces: 2,
      });
    } else {
      amountin[0].update({
        digitGroupSeparator: "",
        decimalCharacter: ".",
        decimalPlaces: 0,
      });
    }
  });
  let tab = "profile";
  $("#donator_phone_number").on("keypress", function (e) {
    if (e.which == 32) {
      return false;
    }
  });

  $(".profile-tabs .profile-tab").on("click", ({ target }) => {
    tab = target.getAttribute("data-tab");

    $(".profile-tab").removeClass("active");
    $(`.profile-tab[data-tab="${tab}"]`).addClass("active");
    $(".profile-content").addClass("hidden-input");
    $(`.profile-content[data-tab="${tab}"]`).removeClass("hidden-input");
  });

  $(".iti__country-list li").click(function () {
    this?.parentElement?.parentElement?.nextSibling?.setAttribute(
      "data-code",
      $(this).data("dial-code")
    );
    formatPhoneNumber();
  });

  $("#phone_number_hidden_input").change(function (e) {
    formatPhoneNumber();
  });

  $(".update-card-button").click((e) => {
    e.preventDefault();
    e.stopPropagation();
    $("#loader").show();
    $.ajax({
      type: "POST",
      url:
        "/update_one_click_card/" +
        e.target.getAttribute("data-subscription-uuid"),
    }).done(function (response) {
      if (response["payment_stream"] == "webpay") {
        const url = response["url"];
        const token = response["token"];
        const form = $(
          '<form action="' +
          url +
          '" method="post">' +
          '<input type="hidden" name="' +
          response["name"] +
          '" value="' +
          token +
          '" />' +
          "</form>"
        );
        $("body").append(form);
        form.submit();
      } else {
        $("#loader").hide();
        alert(
          "Ha ocurrido un problema, te pedimos por favor reintentar más tarde"
        );
      }
    });
  });
});

var currency = $("#donator_subscriptions_attributes_0_currency").val() || "clp";
if (currency == "uf") {
  var amountin = new AutoNumeric.multiple("#amount-field", {
    digitGroupSeparator: "",
    decimalCharacter: ".",
    decimalPlaces: 2,
  });
} else {
  var amountin = new AutoNumeric.multiple("#amount-field", {
    digitGroupSeparator: "",
    decimalCharacter: ".",
    decimalPlaces: 0,
  });
}

const footer_color = $(".donando-footer").attr("data-footer-color");
if (footer_color) {
  const color_type = lightOrDark(footer_color);
  const footer_images = Array.from(document.getElementsByClassName("donando-footer-image"));
  const social_media_icons = $(".social-media-footer-icon");
  if (color_type == "light") {
    footer_images.map((footer) => {
      footer.src =
        "https://storage.googleapis.com/fundingplatform-files/assets/donando/desarrollado-donando.png";
    });
    social_media_icons.each((element, data) => {
      data.style.color = "#000000";
    });
  } else if (color_type == "dark") {
    footer_images.map((footer) => {
      footer.src =
        "https://storage.googleapis.com/fundingplatform-files/assets/donando/desarrollado-donando-negative.png";
    });
    social_media_icons.each((element, data) => {
      data.style.color = "#ffffff";
    });
  }
}

function pickTextColorBasedOnBgColorAdvanced(bgColor, lightColor, darkColor) {
  var color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
  var r = parseInt(color.substring(0, 2), 16); // hexToR
  var g = parseInt(color.substring(2, 4), 16); // hexToG
  var b = parseInt(color.substring(4, 6), 16); // hexToB
  var uicolors = [r / 255, g / 255, b / 255];
  var c = uicolors.map((col) => {
    if (col <= 0.03928) {
      return col / 12.92;
    }
    return Math.pow((col + 0.055) / 1.055, 2.4);
  });
  var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  return L > 0.55 ? darkColor : lightColor;
}
var color = document.getElementById("hidden-color").getAttribute("data-color");
var font_color = pickTextColorBasedOnBgColorAdvanced(color, color, "#000000");
if (font_color == "#000000") {
  $(".dynamic-color").css("color", font_color);
  $(".dynamic-color").css("borderColor", font_color);
}

function validateSubscriptionAmount() {
  const min_amount_json_default = {
    uf: "0.02",
    clp: "1000",
    cop: "5000",
    eur: "1",
    usd: "1",
    pen: "5",
  };
  let min_amount_json;
  if ($("#min-amount").attr("data-min-amount")) {
    min_amount_json = JSON.parse($("#min-amount").attr("data-min-amount"));
  } else {
    min_amount_json = min_amount_json_default;
  }
  let currency = $("#donator_subscriptions_attributes_0_currency").val();
  let amount = $("#amount-field").val();
  let min_amount = min_amount_json[currency];
  if (parseFloat(amount) >= parseFloat(min_amount)) {
    $("#amount-field").removeClass("is-invalid");
    $("#donations").addClass("was-validated");
    $(`#min-amount div.invalid-feedback.payment-${currency}`).hide();
    return true;
  } else {
    $("#amount-field").addClass("is-invalid");
    $("#donations").removeClass("was-validated");
    $(`#min-amount div.invalid-feedback`).hide();
    $(`#min-amount div.invalid-feedback.payment-${currency}`).show();
    return false;
  }
}
